function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("circle", {
  cx: 16.5,
  cy: 16.5,
  r: 16.5,
  fill: "#FDDF6D"
}), React.createElement("path", {
  fill: "#FCC56B",
  d: "M19.645 30.58c-8.935 0-16.178-7.34-16.178-16.394C3.467 9.348 5.535 5 8.823 2 3.586 4.714 0 10.235 0 16.606 0 25.66 7.243 33 16.178 33c4.162 0 7.955-1.593 10.822-4.209a15.938 15.938 0 0 1-7.355 1.789z"
}), React.createElement("g", {
  fill: "#7F184C",
  transform: "translate(12 9)"
}, React.createElement("path", {
  d: "M7.108 17.993c-3.592 0-6.504-2.95-6.504-6.59h13.007c0 3.64-2.912 6.59-6.503 6.59z"
}), React.createElement("ellipse", {
  cx: 1.972,
  cy: 2.02,
  rx: 1.961,
  ry: 1.987
}), React.createElement("ellipse", {
  cx: 13.012,
  cy: 2.02,
  rx: 1.961,
  ry: 1.987
})), React.createElement("path", {
  fill: "#FC4C59",
  d: "M19.449 24.51a6.72 6.72 0 0 0-5.449.138C15.224 26.078 17.15 27 19.316 27A7.34 7.34 0 0 0 22 26.497c-.603-.836-1.468-1.535-2.551-1.986z"
}), React.createElement("g", {
  fill: "#F9A880"
}, React.createElement("path", {
  d: "M9.27 15.386c-1.234 0-2.233 1.156-2.233 2.582h4.465c0-1.426-1-2.582-2.233-2.582zM28.746 15.04c-1.233 0-2.233 1.156-2.233 2.582h4.466c0-1.426-1-2.582-2.233-2.582z"
})), React.createElement("path", {
  fill: "#F2F2F2",
  d: "M14 21v1.134c0 .478.353.866.788.866h8.424c.435 0 .788-.388.788-.866V21H14z"
}), React.createElement("ellipse", {
  cx: 19.893,
  cy: 4.579,
  fill: "#FCEB88",
  rx: 1.92,
  ry: 3.439,
  transform: "rotate(-74.199 19.893 4.58)"
}));

var SvgIconEmojyHappy = function SvgIconEmojyHappy(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIconEmojyHappy, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-emojy-happy.cb1b38a4.svg";
export { ForwardRef as ReactComponent };